import { render, staticRenderFns } from "./third-ticket-list.vue?vue&type=template&id=94c7f0a8&scoped=true&"
import script from "./third-ticket-list.vue?vue&type=script&lang=js&"
export * from "./third-ticket-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c7f0a8",
  null
  
)

export default component.exports